import { useCallback } from "react";
import { sessionParticipantsExporter } from "utils/csvExporters/zoomAttendance/sessionParticipantsExporter";

export const useSessionExport = ({
  exportParticipants,
  notify,
  selectedIds,
}) => {
  const handleExport = useCallback(
    async ({ filterValues = {} } = {}) => {
      const allData = await exportParticipants({ notify, filterValues });
      if (allData && allData.length > 0) {
        let finalExportData = allData;
        if (selectedIds && selectedIds.length > 0) {
          const selectedSet = new Set(
            selectedIds.map((id) => String(id).toLowerCase().trim())
          );
          finalExportData = allData.filter((item, index) => {
            const indexStr = String(index);
            const itemId = item?.id ? String(item.id).toLowerCase().trim() : "";
            const itemUuid = item?.exly_user_uuid
              ? String(item.exly_user_uuid).toLowerCase().trim()
              : "";
            const itemEmail =
              item?.customer_email || item?.user_email
                ? String(item.customer_email || item.user_email)
                    .toLowerCase()
                    .trim()
                : "";
            const itemPhone = item?.customer_phone
              ? String(item.customer_phone).toLowerCase().trim()
              : "";
            return (
              selectedSet.has(indexStr) ||
              (itemId && selectedSet.has(itemId)) ||
              (itemUuid && selectedSet.has(itemUuid)) ||
              (itemEmail && selectedSet.has(itemEmail)) ||
              (itemPhone && selectedSet.has(itemPhone))
            );
          });
        }
        sessionParticipantsExporter(finalExportData);
      }
    },
    [exportParticipants, notify, selectedIds]
  );

  return { handleExport };
};
